const urlParamToUnpaddedB64 = value => btoa(encodeURI(decodeURIComponent(value))).replace(/=+$/, '')

export const getVirusTotalIndicatorLink = (type, value, urlRoot) => {
  let vtType

  if ([type, value, urlRoot].some(value => typeof value !== 'string')) {
    return
  }

  if (['sha1', 'sha256', 'md5'].includes(type)) {
    vtType = 'file'
  }

  if (type === 'url') {
    vtType = 'url'
    value = urlParamToUnpaddedB64(value)
  }

  if (type === 'fqdn') {
    vtType = 'domain'
  }

  if (type === 'ipv4') {
    vtType = 'ip-address'
  }

  if (!vtType) {
    return
  }

  return `${urlRoot}/${vtType}/${value}`
}
